/**
 * BlackVue Fleeta Device List API
 * Central export point for device management functionality
 */

// === MAIN API FUNCTIONS ===
export {
  getDeviceList,
  isDeviceApiReady,
  getDeviceStatus,
  isDeviceAvailableForRegistration
} from './api';

// === MOCK API FUNCTIONS ===
export {
  getDeviceList as getMockDeviceList
} from './mockApi';

// === AUTH UTILITIES ===
export {
  getAuthConfigFromStore,
  isAuthConfigured,
  isAuthConfigValid,
  getAuthHeaders
} from '../auth/authUtils';

// === TYPE EXPORTS ===
export type {
  DeviceListParams,
  DeviceListResponse,
  DeviceListItem,
  DeviceInfo, 
  DeviceGroupData,
  DeviceListStatistics,
  DeviceStatusParams,
  DeviceStatusResponse,
  DeviceRegistrationInfo,
  BatteryInfo,
  CareInfo
} from './types';

// === AUTH CONFIG TYPE ===
export type { AuthConfig } from '../auth/authUtils';

// === CONSTANTS ===
export {
  DEVICE_LIST_ERROR_MESSAGES,
  DEVICE_STATUS_ERROR_MESSAGES,
  DEVICE_MODE_NAMES,
  COMMUNICATION_TYPE_NAMES,
  DEVICE_STATUS_NAMES
} from './types';

// === VERSION INFO ===
export const DEVICE_API_VERSION = '1.0.0';
export const DEVICE_API_NAME = 'BlackVue Fleeta Device List API';